import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Modal from '../components/common/Modal';
import { buildSignInPath, getAuthFlowContent, safeReturnUrl, } from '../utils/authFlow';
const AuthPromptContext = createContext(undefined);
export const AuthPromptProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [request, setRequest] = useState(null);
    const requestSignIn = useCallback((nextRequest) => {
        const currentUrl = `${location.pathname}${location.search}${location.hash}`;
        setRequest({
            intent: nextRequest.intent,
            returnUrl: safeReturnUrl(nextRequest.returnUrl || currentUrl),
        });
    }, [location.hash, location.pathname, location.search]);
    const closePrompt = useCallback(() => setRequest(null), []);
    const content = useMemo(() => request ? getAuthFlowContent(request.intent, request.returnUrl) : null, [request]);
    const continueToSignIn = useCallback(() => {
        if (!request)
            return;
        const signInPath = buildSignInPath(request.returnUrl, request.intent);
        setRequest(null);
        navigate(signInPath);
    }, [navigate, request]);
    const value = useMemo(() => ({ requestSignIn }), [requestSignIn]);
    return (React.createElement(AuthPromptContext.Provider, { value: value },
        children,
        React.createElement(Modal, { isOpen: Boolean(request), onClose: closePrompt, title: content?.title, size: "sm", className: "wt-auth-prompt-modal", footer: (React.createElement(React.Fragment, null,
                React.createElement("button", { type: "button", className: "btn btn-default", onClick: closePrompt }, "Not now"),
                React.createElement("button", { type: "button", className: "btn btn-primary", onClick: continueToSignIn, "data-autofocus": true },
                    React.createElement("i", { className: "fa fa-sign-in", "aria-hidden": "true" }),
                    " Sign In"))) }, content ? (React.createElement("div", { className: "wt-auth-prompt-copy" },
            React.createElement("p", null, content.message),
            React.createElement("p", { className: "text-muted" }, content.continuation))) : null)));
};
export function useAuthPrompt() {
    const context = useContext(AuthPromptContext);
    if (!context) {
        throw new Error('useAuthPrompt must be used within an AuthPromptProvider');
    }
    return context;
}
